import Svg, { G, Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const GooglePayDisabledSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={42} height={24} viewBox="0 0 42 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3773" fill="white">
        <Path d="M0 12C0 5.37258 5.37258 0 12 0H30C36.6274 0 42 5.37258 42 12C42 18.6274 36.6274 24 30 24H12C5.37258 24 0 18.6274 0 12Z" />
      </Mask>
      <Path
        d="M0 12C0 5.37258 5.37258 0 12 0H30C36.6274 0 42 5.37258 42 12C42 18.6274 36.6274 24 30 24H12C5.37258 24 0 18.6274 0 12Z"
        fill="white"
      />
      <Path
        d="M12 0V1H30V0V-1H12V0ZM30 24V23H12V24V25H30V24ZM12 24V23C5.92487 23 1 18.0751 1 12H0H-1C-1 19.1797 4.8203 25 12 25V24ZM42 12H41C41 18.0751 36.0751 23 30 23V24V25C37.1797 25 43 19.1797 43 12H42ZM30 0V1C36.0751 1 41 5.92487 41 12H42H43C43 4.8203 37.1797 -1 30 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3773)"
      />
      <Path
        d="M20.205 12.7099V15.7349H19.245V8.26489H21.79C22.435 8.26489 22.985 8.47989 23.435 8.90989C23.895 9.33989 24.125 9.86489 24.125 10.4849C24.125 11.1199 23.895 11.6449 23.435 12.0699C22.99 12.4949 22.44 12.7049 21.79 12.7049H20.205V12.7099ZM20.205 9.18489V11.7899H21.81C22.19 11.7899 22.51 11.6599 22.76 11.4049C23.015 11.1499 23.145 10.8399 23.145 10.4899C23.145 10.1449 23.015 9.83989 22.76 9.58489C22.51 9.31989 22.195 9.18989 21.81 9.18989H20.205V9.18489Z"
        fill="#B8B8B8"
      />
      <Path
        d="M26.635 10.455C27.345 10.455 27.905 10.645 28.315 11.025C28.725 11.405 28.93 11.925 28.93 12.585V15.735H28.015V15.025H27.975C27.58 15.61 27.05 15.9 26.39 15.9C25.825 15.9 25.355 15.735 24.975 15.4C24.595 15.065 24.405 14.65 24.405 14.15C24.405 13.62 24.605 13.2 25.005 12.89C25.405 12.575 25.94 12.42 26.605 12.42C27.175 12.42 27.645 12.525 28.01 12.735V12.515C28.01 12.18 27.88 11.9 27.615 11.665C27.35 11.43 27.04 11.315 26.685 11.315C26.15 11.315 25.725 11.54 25.415 11.995L24.57 11.465C25.035 10.79 25.725 10.455 26.635 10.455ZM25.395 14.165C25.395 14.415 25.5 14.625 25.715 14.79C25.925 14.955 26.175 15.04 26.46 15.04C26.865 15.04 27.225 14.89 27.54 14.59C27.855 14.29 28.015 13.94 28.015 13.535C27.715 13.3 27.3 13.18 26.765 13.18C26.375 13.18 26.05 13.275 25.79 13.46C25.525 13.655 25.395 13.89 25.395 14.165Z"
        fill="#B8B8B8"
      />
      <Path
        d="M34.15 10.62L30.95 17.98H29.96L31.15 15.405L29.04 10.62H30.085L31.605 14.29H31.625L33.105 10.62H34.15Z"
        fill="#B8B8B8"
      />
      <G opacity={0.48}>
        <Path
          d="M16.3866 12.1C16.3866 11.787 16.3586 11.4875 16.3066 11.1995H12.2826V12.8495L14.6001 12.85C14.5061 13.399 14.2036 13.867 13.7401 14.179V15.2495H15.1196C15.9251 14.504 16.3866 13.402 16.3866 12.1Z"
          fill="#4285F4"
        />
        <Path
          d="M13.7406 14.1789C13.3566 14.4379 12.8621 14.5894 12.2836 14.5894C11.1661 14.5894 10.2181 13.8364 9.87857 12.8214H8.45557V13.9254C9.16057 15.3244 10.6096 16.2844 12.2836 16.2844C13.4406 16.2844 14.4126 15.9039 15.1201 15.2489L13.7406 14.1789Z"
          fill="#34A853"
        />
        <Path
          d="M9.7445 12.0025C9.7445 11.7175 9.792 11.442 9.8785 11.183V10.079H8.4555C8.164 10.6575 8 11.3105 8 12.0025C8 12.6945 8.1645 13.3475 8.4555 13.926L9.8785 12.822C9.792 12.563 9.7445 12.2875 9.7445 12.0025Z"
          fill="#FABB05"
        />
        <Path
          d="M12.2836 9.41497C12.9151 9.41497 13.4806 9.63247 13.9271 10.0575L15.1496 8.83597C14.4071 8.14447 13.4391 7.71997 12.2836 7.71997C10.6101 7.71997 9.16057 8.67997 8.45557 10.079L9.87857 11.183C10.2181 10.168 11.1661 9.41497 12.2836 9.41497Z"
          fill="#E94235"
        />
      </G>
    </Svg>
  )
}
